var map = {
	"./components/auth-tabs/auth.module": [
		"./src/app/components/auth-tabs/auth.module.ts",
		"components-auth-tabs-auth-module"
	],
	"./components/change-password/change-password.module": [
		"./src/app/components/change-password/change-password.module.ts",
		"components-change-password-change-password-module"
	],
	"./components/chat/chat.module": [
		"./src/app/components/chat/chat.module.ts",
		"components-chat-chat-module"
	],
	"./components/comments/comments.module": [
		"./src/app/components/comments/comments.module.ts",
		"components-comments-comments-module"
	],
	"./components/followers/followers.module": [
		"./src/app/components/followers/followers.module.ts",
		"components-followers-followers-module"
	],
	"./components/following/following.module": [
		"./src/app/components/following/following.module.ts",
		"components-following-following-module"
	],
	"./components/images/images.module": [
		"./src/app/components/images/images.module.ts",
		"components-images-images-module"
	],
	"./components/notifications/notifications.module": [
		"./src/app/components/notifications/notifications.module.ts",
		"components-notifications-notifications-module"
	],
	"./components/people/people.module": [
		"./src/app/components/people/people.module.ts",
		"components-people-people-module"
	],
	"./components/streams/streams.module": [
		"./src/app/components/streams/streams.module.ts",
		"components-streams-streams-module"
	],
	"./components/view-user/view-user.module": [
		"./src/app/components/view-user/view-user.module.ts",
		"components-view-user-view-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;